import { c as _c } from "react/compiler-runtime";
import { reactive } from '@legendapp/state/react';
import { type DetailedHTMLProps, type HTMLAttributes, type InputHTMLAttributes, type ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Typography } from '@/components/Typography';
import { cn } from '@/lib/cn';
import type { Site } from '@/services/rental-api-client';
import { motionFadeUp } from '@/styles/motionAnimations';
import { LocationSelectListItem } from './LocationSelectListItem';
import { ValueField } from './ValueField';
export interface LabeledValueFieldProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, 'onChange'> {
  label: ReactNode;
  selectedSite?: Site;
  placeholder?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange'];
}
function LabeledValueField(t0) {
  const $ = _c(29);
  let checked;
  let children;
  let className;
  let name;
  let onChange;
  let placeholder;
  let props;
  let selectedSite;
  let value;
  if ($[0] !== t0) {
    const {
      label,
      selectedSite: t1,
      placeholder: t2,
      className: t3,
      checked: t4,
      onChange: t5,
      name: t6,
      value: t7,
      children: t8,
      ...t9
    } = t0;
    selectedSite = t1;
    placeholder = t2;
    className = t3;
    checked = t4;
    onChange = t5;
    name = t6;
    value = t7;
    children = t8;
    props = t9;
    $[0] = t0;
    $[1] = checked;
    $[2] = children;
    $[3] = className;
    $[4] = name;
    $[5] = onChange;
    $[6] = placeholder;
    $[7] = props;
    $[8] = selectedSite;
    $[9] = value;
  } else {
    checked = $[1];
    children = $[2];
    className = $[3];
    name = $[4];
    onChange = $[5];
    placeholder = $[6];
    props = $[7];
    selectedSite = $[8];
    value = $[9];
  }
  let t1;
  if ($[10] !== className) {
    t1 = cn("labeled-value-field flex flex-col gap-3 group/label", className);
    $[10] = className;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== checked || $[13] !== name || $[14] !== onChange || $[15] !== value) {
    t2 = <input type="checkbox" className="hidden" name={name} value={value} checked={checked} onChange={onChange} />;
    $[12] = checked;
    $[13] = name;
    $[14] = onChange;
    $[15] = value;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const t3 = selectedSite?.siteCode || "placeholder";
  let t4;
  if ($[17] !== placeholder || $[18] !== selectedSite) {
    t4 = selectedSite?.siteCode ? <LocationSelectListItem as="div" site={selectedSite} /> : <Typography as="div" variant="paragraph-heavy">{placeholder}</Typography>;
    $[17] = placeholder;
    $[18] = selectedSite;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t3 || $[21] !== t4) {
    t5 = <ValueField><AnimatePresence mode="popLayout" initial={false}><motion.div key={t3} {...motionFadeUp} className="flex items-center">{t4}</motion.div></AnimatePresence></ValueField>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== children || $[24] !== props || $[25] !== t1 || $[26] !== t2 || $[27] !== t5) {
    t6 = <label className={t1} {...props}>{t2}{t5}{children}</label>;
    $[23] = children;
    $[24] = props;
    $[25] = t1;
    $[26] = t2;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  return t6;
}
export const ReactiveLabeledValueField = reactive(LabeledValueField);